module.exports = __webpack_public_path__ + "static/media/contact-wally.b5eeae01.svg";